// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"570":"160caae3","650":"42be45d6","893":"e15288e4"}[chunkId] + ".chunk.css";
};